<hpf-marker-form
        [marker]="marker"
        [loading]="marker.isNew()"
        (update)="onUpdate()"
        (delete)="onDelete()"
    ></hpf-marker-form>
